/* ============================================================
   BD - LittleLoca Header JavaScript
   File: assets/bd-header.js
   Author: Biswarup Das
   Features:
     - Search bar toggle
     - Mobile nav drawer open/close
     - Mobile accordion menu
     - Sticky header shadow on scroll
     - Cart count live update
   ============================================================ */

(function () {
  'use strict';

  // DOM ready হলে শুরু
  document.addEventListener('DOMContentLoaded', function () {

    /* --------------------------------------------------------
       1. ELEMENT REFERENCES
       -------------------------------------------------------- */
    const header          = document.getElementById('bd-header');
    const searchBar       = document.getElementById('bd-search-bar');
    const searchToggle    = document.getElementById('bd-search-toggle');
    const searchToggleMob = document.getElementById('bd-search-toggle-mobile');
    const searchClose     = document.getElementById('bd-search-close');
    const hamburger       = document.getElementById('bd-hamburger-btn');
    const mobileNav       = document.getElementById('bd-mobile-nav');
    const mobileOverlay   = document.getElementById('bd-mobile-overlay');
    const mobileClose     = document.getElementById('bd-mobile-close');
    const accordions      = document.querySelectorAll('.bd-mobile-nav__accordion');

    /* --------------------------------------------------------
       2. SEARCH BAR TOGGLE
       -------------------------------------------------------- */
    function openSearch() {
      searchBar.classList.add('is-open');
      searchBar.setAttribute('aria-hidden', 'false');
      // Input এ focus দাও
      setTimeout(() => {
        const input = searchBar.querySelector('.bd-search-bar__input');
        if (input) input.focus();
      }, 400);
    }

    function closeSearch() {
      searchBar.classList.remove('is-open');
      searchBar.setAttribute('aria-hidden', 'true');
    }

    if (searchToggle)    searchToggle.addEventListener('click', openSearch);
    if (searchToggleMob) searchToggleMob.addEventListener('click', openSearch);
    if (searchClose)     searchClose.addEventListener('click', closeSearch);

    // ESC key দিয়ে search close
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeSearch();
        closeMobileNav();
      }
    });

    /* --------------------------------------------------------
       3. MOBILE NAV DRAWER
       -------------------------------------------------------- */
    function openMobileNav() {
      mobileNav.classList.add('is-open');
      mobileNav.setAttribute('aria-hidden', 'false');
      mobileOverlay.classList.add('is-open');
      mobileOverlay.style.display = 'block';
      hamburger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden'; // Scroll lock
    }

    function closeMobileNav() {
      mobileNav.classList.remove('is-open');
      mobileNav.setAttribute('aria-hidden', 'true');
      mobileOverlay.classList.remove('is-open');
      hamburger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';       // Scroll restore
      // Overlay display none after animation
      setTimeout(() => {
        mobileOverlay.style.display = 'none';
      }, 500);
    }

    if (hamburger)      hamburger.addEventListener('click', openMobileNav);
    if (mobileClose)    mobileClose.addEventListener('click', closeMobileNav);
    if (mobileOverlay)  mobileOverlay.addEventListener('click', closeMobileNav);

    /* --------------------------------------------------------
       4. MOBILE ACCORDION — Sub menu open/close
       -------------------------------------------------------- */
    accordions.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const isOpen    = btn.getAttribute('aria-expanded') === 'true';
        const subMenu   = btn.nextElementSibling; // ul.bd-mobile-nav__sub

        // সব accordion বন্ধ করো
        accordions.forEach(function (otherBtn) {
          otherBtn.setAttribute('aria-expanded', 'false');
          const otherSub = otherBtn.nextElementSibling;
          if (otherSub) otherSub.classList.remove('is-open');
        });

        // Click করা টা toggle করো
        if (!isOpen) {
          btn.setAttribute('aria-expanded', 'true');
          if (subMenu) subMenu.classList.add('is-open');
        }
      });
    });

    /* --------------------------------------------------------
       5. STICKY HEADER — Scroll এ shadow বাড়ে
       -------------------------------------------------------- */
    let lastScroll = 0;

    window.addEventListener('scroll', function () {
      const currentScroll = window.pageYOffset;

      if (currentScroll > 50) {
        header.style.boxShadow = '0 4px 24px rgba(167, 216, 255, 0.25)';
      } else {
        header.style.boxShadow = '0 2px 16px rgba(167, 216, 255, 0.12)';
      }

      lastScroll = currentScroll;
    });

    /* --------------------------------------------------------
       6. CART COUNT UPDATE
       Shopify cart change হলে badge update হবে
       -------------------------------------------------------- */
    document.addEventListener('cart:updated', function (e) {
      const countEl = document.getElementById('bd-cart-count');
      if (!countEl) return;

      const count = e.detail?.itemCount || 0;
      countEl.textContent = count;
      countEl.style.display = count > 0 ? 'flex' : 'none';
    });

  }); // DOMContentLoaded end

  /* --------------------------------------------------------
       TYPEWRITER EFFECT — Search placeholder rotating text
       -------------------------------------------------------- */
    const typeWords = [
      'Lehenga Set ...',
      'Co-ord Set ...',
      'Dresses ...',
      'Kurta Set ...',
      'Salwar Set ...',
      'Sharara Set ...',
      'Titli Set ...',
      'Waistcoat ...',
      'Zoya Set ...'
    ];

    const typePrefix       = 'Search for ';
    const typeSpeed        = 80;
    const deleteSpeed      = 40;
    const pauseAfterType   = 1800;
    const pauseAfterDelete = 400;

    let twWordIndex  = 0;
    let twCharIndex  = 0;
    let twDeleting   = false;

    function setSearchPlaceholder(text) {
    // Visible typewriter span update করো
    var twEl = document.getElementById('bd-typewriter');
    if (twEl) twEl.textContent = typePrefix + text;

    // Search bar input placeholder ও update করো
    document.querySelectorAll('.bd-search-bar__input').forEach(function (el) {
        el.setAttribute('placeholder', typePrefix + text);
    });
    }

    function runTypeWriter() {
      const word = typeWords[twWordIndex];

      if (twDeleting) {
        twCharIndex--;
      } else {
        twCharIndex++;
      }

      setSearchPlaceholder(word.substring(0, twCharIndex));

      let delay = twDeleting ? deleteSpeed : typeSpeed;

      if (!twDeleting && twCharIndex === word.length) {
        delay      = pauseAfterType;
        twDeleting = true;
      } else if (twDeleting && twCharIndex === 0) {
        twDeleting  = false;
        twWordIndex = (twWordIndex + 1) % typeWords.length;
        delay       = pauseAfterDelete;
      }

      setTimeout(runTypeWriter, delay);
    }

    // ৮০০ms delay দিয়ে শুরু
    setTimeout(runTypeWriter, 800);

})();

